import React from "react";
// Nếu không cài react-icons thì xóa dòng import này và dùng SVG bên dưới
import { FaCheckCircle, FaFacebookSquare } from "react-icons/fa"; 

const FacebookPageEmbed = () => {
  return (
    <div className="w-full flex justify-center py-8">
      {/* SỬA: Đổi max-w-lg thành max-w-2xl để khung rộng ra như cũ */}
      <div className="w-full max-w-2xl rounded-2xl shadow-xl bg-white border border-gray-100 overflow-hidden">
        
        {/* PHẦN MÔ TẢ XANH (HEADER) */}
        <div className="bg-emerald-50/80 p-6 border-b border-emerald-100 backdrop-blur-sm">
          <div className="flex items-center gap-3 mb-2">
            {/* Icon Facebook xanh */}
            <div className="p-2 bg-white rounded-lg shadow-sm text-blue-600">
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                 <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
               </svg>
            </div>
            
            <div>
              <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                Official Community
                {/* Badge tích xanh */}
                <span className="text-blue-500" title="Verified Channel">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                    <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                  </svg>
                </span>
              </h2>
              <p className="text-xs font-semibold text-emerald-600 uppercase tracking-wide">
                System Updates & Support
              </p>
            </div>
          </div>

          <div className="bg-emerald-100/50 rounded-lg p-3 border border-emerald-100/50">
            <p className="text-sm text-emerald-800 leading-relaxed font-medium">
              Join our verified channel to receive real-time system status updates, maintenance logs, and platform announcements directly from the engineering team.
            </p>
          </div>
        </div>

        {/* PHẦN IFRAME */}
        <div className="bg-gray-50 p-1 flex justify-center">
          <iframe
            title="Hust Media Facebook Page"
            // SỬA: width=500 (Max của Facebook) để nó tràn khung đẹp hơn
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fhustmedia&tabs=timeline&width=500&height=800&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
            className="w-full h-[600px] md:h-[700px] rounded-b-xl" 
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default FacebookPageEmbed;